module.exports = __webpack_public_path__ + "img/sld_isolator_t1_b1_disable.9ca8005f.svg";